<div class="video-dialog" (keydown.arrowleft)="step(-1)" (keydown.arrowright)="step(1)" tabindex="0">
  <header class="video-dialog-head">
    <div class="head-text">
      <span class="head-kind">Video</span>
      <span class="head-title" *ngIf="title">{{ title }}</span>
      <span class="head-slot" *ngIf="video">Slot {{ video.place }}</span>
    </div>
    <button mat-icon-button mat-dialog-close aria-label="Close" class="head-close">
      <mat-icon>close</mat-icon>
    </button>
  </header>

  <div class="video-stage">
    <button mat-icon-button class="stage-step stage-prev" *ngIf="hasMultiple"
            (click)="step(-1)" aria-label="Previous video">
      <mat-icon>chevron_left</mat-icon>
    </button>

    <video #player *ngIf="playable" class="stage-player" controls autoplay playsinline
           [poster]="video.poster_url || ''" [src]="source"></video>

    <!-- A video that is still transcoding, or was turned away by moderation,
         has no bytes to play. Say which, rather than showing a dead player. -->
    <div class="stage-empty" *ngIf="!playable && video">
      <mat-icon class="empty-icon">movie_filter</mat-icon>
      <div class="empty-status" [ngClass]="'status-' + video.status">{{ statusLabel }}</div>
      <div class="empty-reason" *ngIf="video.status_reason">{{ video.status_reason }}</div>
      <div class="empty-hint" *ngIf="!video.status_reason">
        This video has no playable file yet.
      </div>
    </div>

    <button mat-icon-button class="stage-step stage-next" *ngIf="hasMultiple"
            (click)="step(1)" aria-label="Next video">
      <mat-icon>chevron_right</mat-icon>
    </button>
  </div>

  <footer class="video-dialog-meta" *ngIf="video">
    <span class="meta-pill" *ngIf="duration">{{ duration }}</span>
    <span class="meta-pill" *ngIf="dimensions">{{ dimensions }}</span>
    <span class="meta-pill" [class.meta-muted]="!video.has_audio">
      {{ video.has_audio ? 'Has audio' : 'No audio' }}
    </span>
    <span class="meta-pill" *ngIf="video.is_primary">Primary</span>
    <span class="meta-pill meta-status" [ngClass]="'status-' + video.status">{{ statusLabel }}</span>
    <span class="meta-caption" *ngIf="video.caption">“{{ video.caption }}”</span>
    <span class="meta-count" *ngIf="hasMultiple">{{ index + 1 }} / {{ videos.length }}</span>
  </footer>
</div>
